module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms55x"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp && _vm.callFrom == 'hrms55x'),
      expression: "indexDisp && callFrom == 'hrms55x'"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms55xIndex,
      "csvExportDisp": true,
      "searchBoxAlias": _vm.callFrom,
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('hrms-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp && _vm.callFrom == 'hrms55x2'),
      expression: "indexDisp && callFrom == 'hrms55x2'"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms55xIndex,
      "csvExportDisp": false,
      "searchBoxAlias": _vm.callFrom,
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e3b27fa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms55x/component.vue
// module id = 4001
// module chunks = 1